import moment from "moment";
import React, { useContext, useState, useEffect } from "react";
import {
	Button,
	Form,
	Modal
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoaderContext } from "../../../../App";
import FormService from "../../../../core/service/FormService";
import ReactDatePicker from "react-datepicker";

function AssessmentExpiryEditModal({ t, assessment, onHide, onSuccess }) {

	const { setLoaderDisplay } = useContext(LoaderContext);
	const [dataToSave, setDataToSave] = useState({
		id: assessment.id,
		lastSubmissionDate: assessment.lastSubmissionDate,
		period: assessment.period,
		updateExpiryOnly: true,
		reShare: false,
		assessmentForm: {
			id: assessment?.assessmentForm?.id,
		},
		remindBefore: assessment.remindBefore,
		daysOffset: assessment.daysOffset,
		reminderEnabled: assessment.reminderEnabled,
	});

	const updateAssessmentExpiry = () => {
		setLoaderDisplay(true);
		FormService.updateAssessment(assessment.id, dataToSave).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			onSuccess();
		}).catch(err => { setLoaderDisplay(false); })
	};

	const canDsiplayNotifyOptions = () => {
		const lastSubmissionDate = new Date(assessment.lastSubmissionDate);
		const isExpired = lastSubmissionDate < new Date();
		if (!assessment.sharedOn && !isExpired) return false;

		return dataToSave.lastSubmissionDate !== assessment.lastSubmissionDate;
	};

	return (
		<>
			<Modal show={true} onHide={() => onHide()}
				aria-labelledby="contained-modal-title-vcenter"
				size="sm"
				centered>
				<Modal.Header closeButton className="border-0">
					 <Modal.Title as="h5">
						{t('EditExpiryDate.label')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<div className="py-2">
						<label className="mb-2">{t('Expiry.label')}</label>
						<ReactDatePicker
							selected={new Date(dataToSave.lastSubmissionDate)}
							onChange={(date) => {
								setDataToSave({
									...dataToSave,
									lastSubmissionDate: moment(date).format('YYYY-MM-DD')
								});
							}}
							className="form-control"
							required
							dateFormat="dd/MM/yyyy"
							minDate={new Date()}
						/>
					</div>
					{  
						canDsiplayNotifyOptions() && 
						<div className="py-2">
							<div className="mb-2">{t('NotifySharedGroups.label')}</div>
							<Form.Check
								inline
								label={t("Yes.label")}
								type="radio"
								id="yesRadio"
								value={false}
								checked={dataToSave.reShare ? "checked" : ""}
								onChange={(e) => setDataToSave({ ...dataToSave, reShare: true })} />
							<Form.Check
								inline
								label={t("No.label")}
								type="radio"
								id="noRadio"
								value={false}
								checked={dataToSave.reShare ? "" : "checked"}
								onChange={(e) => setDataToSave({ ...dataToSave, reShare: false })} />
						</div>					
					}

				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" className="px-3" onClick={() => updateAssessmentExpiry()}>{t('Update.label')}</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default withTranslation()(AssessmentExpiryEditModal);